import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { analyticsTrack } from '../../analyticsUtils';
import marketingImage1 from '../../../assets/images/human-Space-marketing.svg';
import arrowIcon from '../../../assets/images/icons/arrow-right.png';
import './MarketingMessages.scss';

const handleButtonClick = (projectId) => {
  analyticsTrack('Clicked on Sales/Marketing Banner', { location: 'timesheet' });
  window.open(`/featured?project_id=${projectId}`, '_blank');
};

function MarketingMessages({ aoes, projectId, position }) {
  return (
    <div className={`marketing-messages ${position !== 'Top' && 'mb-3'}`}>
      <div className="marketing-messages__container">
        {position !== 'Top' && (
        <img
          src={marketingImage1}
          alt="Sales/Marketing"
          className="marketing-messages__image"
        />
        )}
        <div className="marketing-messages__content">

          {position === 'Top'
            ? (
              <p className="marketing-messages__text-light">
                {`Need more ${aoes[0] || 'Clinical Operations'} experts? See who is available`}
                {position === 'Top'
            && (
            <button
              onClick={() => handleButtonClick(projectId)}
              className="marketing-messages__btn"
            >
              <img alt="Arrow" src={arrowIcon} />
            </button>
            )}
              </p>
            )
            : (
              <Fragment>
                <p className="marketing-messages__text">
                  {`Need more ${aoes[0] || 'Clinical Operations'} experts? We've got em.`}
                </p>
                <button
                  onClick={() => handleButtonClick(projectId)}
                  className="marketing-messages__link"
                >
                  Explore consultants with availability
                </button>
              </Fragment>
            )}
        </div>
      </div>
    </div>
  );
}

MarketingMessages.propTypes = {
  aoes: PropTypes.shape([]),
  position: PropTypes.string,
  projectId: PropTypes.string,
};

MarketingMessages.defaultProps = {
  position: 'Top',
  aoes: [],
  projectId: '',
};

export default MarketingMessages;
